import _ from 'underscore';

function getParameterNamesInSQLQuery(sqlQuery: string): Array<string> {
  const parameterNames = [];
  // Declare inline, instead of as a module-level constant, since JS RegExp objects are stateful.
  // Keep in sync with back-end _PARAMETER_TAG_REGEX.
  const parameterTagRegex = /{{(.+?)}}/g;
  let match: RegExpExecArray | null;
  // Cleanest way to write this loop until JavaScript has a matchAll function:
  // https://github.com/airbnb/javascript/issues/1439#issue-233638459
  // eslint-disable-next-line no-cond-assign
  while ((match = parameterTagRegex.exec(sqlQuery)) != null) {
    parameterNames.push(match[1]);
  }
  return _.unique(parameterNames);
}

export default function getParameterNamesInSQLQueries(sqlQueries: Array<string>): Array<string> {
  return _.union(...sqlQueries.map((sqlQuery) => getParameterNamesInSQLQuery(sqlQuery)));
}
